/**
 * Supported property types
 * Should mirror the PropertyType enum in models.py
 * Except backend does not support the empty string one (that's just for UI)
 */
export enum PropertyType {
    Apartment = 'Apartment',
    ApartmentBuilding = 'Apartment Building',
    ApartmentFloorPlan = 'Apartment Floor Plan',
    Condo = 'Condo',
    House = 'House',
    Room = 'Room',
    Townhouse = 'Townhouse',
    Community = 'Community',
}

export const propertyTypes = Object.values(PropertyType);
export const propertyTypeOptions = propertyTypes.map((type) => ({
    label: type,
    value: type,
}));

export interface IShowingSchedulingLink {
    id: number;
    property_id: number;
    leasing_team_id: number;
    link: string;
    created_at: Date;
    modified_at: Date;
}

export interface IPropertyApplicationLink {
    id: number;
    property_id: number;
    leasing_team_id: number;
    link: string;
    created_at: Date;
    modified_at: Date;
}


export const propertyTypeParentToChild: Record<PropertyType, readonly PropertyType[]> = {
    [PropertyType.Apartment]: [PropertyType.Room],
    [PropertyType.ApartmentBuilding]: [PropertyType.ApartmentFloorPlan, PropertyType.Apartment, PropertyType.Room, PropertyType.Condo],
    [PropertyType.ApartmentFloorPlan]: [PropertyType.Apartment, PropertyType.Room, PropertyType.Condo],
    [PropertyType.Community]: [PropertyType.Apartment, PropertyType.ApartmentBuilding, PropertyType.ApartmentFloorPlan,
        PropertyType.Condo, PropertyType.House, PropertyType.Room, PropertyType.Townhouse],
    [PropertyType.Condo]: [PropertyType.Room],
    [PropertyType.House]: [PropertyType.Room],
    [PropertyType.Room]: [],
    [PropertyType.Townhouse]: [PropertyType.Room],
} as const;

export const propertyTypeChildToParent: Record<PropertyType, readonly PropertyType[]> = {
    [PropertyType.Room]: [PropertyType.Apartment, PropertyType.ApartmentBuilding, PropertyType.ApartmentFloorPlan,
        PropertyType.Community, PropertyType.Condo, PropertyType.House, PropertyType.Townhouse],
    [PropertyType.Apartment]: [PropertyType.ApartmentBuilding, PropertyType.ApartmentFloorPlan, PropertyType.Community],
    [PropertyType.ApartmentFloorPlan]: [PropertyType.ApartmentBuilding, PropertyType.Community],
    [PropertyType.ApartmentBuilding]: [PropertyType.Community],
    [PropertyType.Condo]: [PropertyType.ApartmentBuilding, PropertyType.ApartmentFloorPlan, PropertyType.Community],
    [PropertyType.House]: [PropertyType.Community],
    [PropertyType.Townhouse]: [PropertyType.Community],
    [PropertyType.Community]: [],
} as const;
